import UserService from 'core/services/user_service'
import { UserBox } from 'carpool_shared/components/user_box'
import React from 'react'
import ReactDOM from 'react-dom'

export default class HeaderLoginUi {
  constructor(el) {
    this.ui = {
      loginButton: el.querySelector('.login-button'),
      logoutButton: el.querySelector('.logout-button'),
      loggedInUser: el.querySelector('.logged-in-user'),
      accountButton: el.querySelector('.account-button')
    }

    if (this.ui.loginButton) {
      this.init()
    } else {
      console.error('some login UI elements are missing')
    }
  }

  init() {
    if (this.ui.logoutButton) {
      this.ui.logoutButton.addEventListener('click', e => {
        e.preventDefault()
        new UserService().logout().then(() => location.reload())
      })
    }
    new UserService().getCurrent().done(user => this.updateUserState(user))
  }

  updateUserState(user) {
    this.toggle(this.ui.loginButton, 'wz-hidden', user !== null)
    if (this.ui.logoutButton) {
      this.toggle(this.ui.logoutButton, 'wz-hidden', user === null)
      this.toggle(this.ui.accountButton, 'wz-hidden', user === null)
    }
    if (this.ui.loggedInUser && user) {
      this.toggle(this.ui.loggedInUser, 'wz-hidden', false)
      ReactDOM.render(
        React.createElement(
          UserBox,
          {
            userName: user.getFirstAndLastName(),
            imageUrl: user.getProfileImageUrl(),
            email: user.getEmail(),
            riderOnboarded: user.isCarpoolRider && user.carpoolOnboarded
          },
          null
        ),
        this.ui.loggedInUser
      )
    }
  }

  toggle(el, cls, flag) {
    if (flag) {
      el.classList.add(cls)
    } else {
      el.classList.remove(cls)
    }
  }
}
